const SELECTOR = '[data-scroll-reveal]';
const motion = matchMedia('(prefers-reduced-motion: no-preference)');

const finish = (element) => {
  observer.unobserve(element);
  for (const animation of element.getAnimations()) {
    if (animation.animationName === 'scroll-reveal') animation.finish();
  }
  element.dataset.scrollReveal = 'done';
};

const unseen = ({ top, width, height }) => top >= innerHeight || (width === 0 && height === 0);

const observer = new IntersectionObserver((entries) => {
  for (const { target, isIntersecting, boundingClientRect } of entries) {
    const state = target.dataset.scrollReveal;
    if (!isIntersecting) {
      if (state !== '') continue;
      if (unseen(boundingClientRect)) target.dataset.scrollReveal = 'hidden';
      else finish(target);
    } else if (state === 'hidden' && motion.matches) {
      observer.unobserve(target);
      target.dataset.scrollReveal = 'in';
    } else {
      finish(target);
    }
  }
}, { rootMargin: '0px 0px -12% 0px' });

const observe = (root) => {
  for (const element of root.querySelectorAll('[data-scroll-reveal=""]')) observer.observe(element);
};

const revealWithin = (node) => {
  if (!(node instanceof Element)) return;
  const owner = node.closest(SELECTOR);
  if (owner) finish(owner);
  for (const element of (node.closest('.shopify-section') ?? node).querySelectorAll(SELECTOR)) finish(element);
};

const revealHash = (hash) => {
  let id = hash.slice(1);
  try {
    id = decodeURIComponent(id);
  } catch {}
  if (id) revealWithin(document.getElementById(id));
};

const settle = (event) => {
  if (event.animationName === 'scroll-reveal' && event.target.dataset.scrollReveal === 'in') finish(event.target);
};

if (motion.matches) {
  observe(document);
  revealHash(location.hash);
  document.addEventListener('animationend', settle);
  document.addEventListener('animationcancel', settle);
  document.addEventListener('focusin', (event) => {
    const owner = event.target.closest?.(SELECTOR);
    if (owner && owner.dataset.scrollReveal !== 'done') finish(owner);
  });
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[href*="#"]');
    if (link?.hash && link.pathname === location.pathname) revealHash(link.hash);
  });
  addEventListener('hashchange', () => revealHash(location.hash));
  document.addEventListener('shopify:section:load', (event) => observe(event.target));
  document.addEventListener('shopify:section:select', (event) => revealWithin(event.target));
  document.addEventListener('shopify:block:select', (event) => revealWithin(event.target));
}
